import type { CSSProperties } from "react";
import { Badge as IntentBadge, type BadgeProps as IntentBadgeProps } from "@/components/ui/badge.tsx";

export type BadgeIntent = NonNullable<IntentBadgeProps["intent"]> | "muted";

export interface BadgeProps extends Omit<IntentBadgeProps, "intent"> {
    intent?: BadgeIntent;
}

const MUTED_STYLE = {
    "--badge-bg": "var(--color-muted)",
    "--badge-fg": "var(--color-muted-fg)"
} as CSSProperties;

export function Badge({ intent, style, ...props }: BadgeProps) {
    if (intent === "muted") {
        return <IntentBadge {...props} intent="secondary" style={{ ...MUTED_STYLE, ...style }} />;
    }

    return <IntentBadge {...props} intent={intent} style={style} />;
}
